module.exports = __webpack_public_path__ + "static/key-helloneighbor-c7eba83fa94b104c9ae90ce803ed9a6f.webp";